<script setup lang="ts">
//vue
import { reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import {f2dec, fdata} from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";

const controle = reactive({
  parceiro: null as clienteService.Parceiro | null,
  status: "" as string,
  erro: "" as string
});

const route = useRoute();

onMounted(() => {
    console.log("Mounted Parceiro.vue");
    if (route.params.parceiroId) {
        const parceiroId = Number(route.params.parceiroId);
        controle.status = "Buscando parceiro...";
        console.log("parceiroId:", parceiroId);
        clienteService.obterParceiros({ parceiroId: parceiroId } as clienteService.ClienteParceirosFiltros)
            .then((r) => {
                controle.status = "";
                controle.parceiro = r.dados[0];
            })
            .catch((error) => {
                console.error("Erro ao buscar parceiro:", error);
                controle.status = "";
                controle.erro = error.message || "Erro desconhecido";
            });
    } else {
        controle.erro = "ID do parceiro não fornecido na URL.";
    }
});


function sair() {
    // Lógica para sair da área do cliente
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    window.location.reload();
}

</script>

<template>
    <div class="row mt-4">
        <div class="col-md-12 text-center">
            <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
        </div>
    </div>

     <div class="row mt-4 mb-3">
        <div class="col-md-12">
            <h2>Parceiro</h2>
        </div>
    </div>

   <div class="row">
        <div class="col-md-12">
            <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
            <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12">
            <h3>{{controle.parceiro?.nome}}</h3>
        </div>
        <div class="col-md-12">
            
            <div> Desconto Inicial: {{f2dec(controle.parceiro?.valorDescontoIni)}} %</div>
            <div> Desconto : {{f2dec(controle.parceiro?.valorDesconto)}} %</div>
            <div> Telefone: {{controle.parceiro?.telefone}}</div>
            <div> Logradouro: {{controle.parceiro?.logradouro}}</div>
            <div> Número: {{controle.parceiro?.numero}}</div>
            <div> Bairro: {{controle.parceiro?.bairro}}</div>
            <div> CEP: {{controle.parceiro?.cep}}</div>
            <div> Cidade: {{controle.parceiro?.cidade?.nome}}</div>
            <div> Estado: {{controle.parceiro?.cidade?.estado}}</div>
            <div> CEP: {{controle.parceiro?.cep}}</div>
            <div> CNPJ/CPF: {{controle.parceiro?.cnpj}}</div>
            <div> Responsável: {{controle.parceiro?.responsavel}}</div>
            <div> Texto: {{controle.parceiro?.texto}}</div>
        </div>
        <div class="col-md-12 mt-3 mb-5">
            <RouterLink class="btn btn-secondary btn-sm  mb-5" to="/cliente">
                <i class="flaticon-left-arrow"></i> Voltar
            </RouterLink>
        </div>
    </div>

</template>


<style lang="css" scoped>

</style>